import React, { createContext, useContext, useState, useEffect } from 'react'
import { ConfigProvider } from 'antd'
import ja_JP from 'antd/lib/locale/ja_JP'
import en_US from 'antd/lib/locale/en_US'
import { LanguageEnum } from '../until/constant'

type LanguageContextType = {
  lang: LanguageEnum;
  // eslint-disable-next-line no-unused-vars
  setLang: (newLang: LanguageEnum) => void; 
  locale: typeof en_US | typeof ja_JP;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined)

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<LanguageEnum>(() => {
    const savedLang = localStorage.getItem('lang')
    return (savedLang === LanguageEnum.ENGLISH ? LanguageEnum.ENGLISH : LanguageEnum.JAPANESE) 
  })
  useEffect(() => {
    localStorage.setItem('lang', lang)
  }, [lang])

  const getLocale = (): typeof en_US | typeof ja_JP => {
    switch (lang) {
      case LanguageEnum.ENGLISH:
        return en_US
      case LanguageEnum.JAPANESE:
      default:
        return ja_JP
    }
  }

  const value: LanguageContextType = {
    lang,
    setLang: (newLang: LanguageEnum) => setLang(newLang), 
    locale: getLocale(), 
  }

  return (
    <LanguageContext.Provider value={value}>
      <ConfigProvider locale={value.locale}>{children}</ConfigProvider>
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}